import { CircularProgress } from '@mui/material';
import React, { FC } from 'react';
import './Loader.scss';

const PageLoader: FC = () => (
	<div className="PageLoader">
		<div className="PageLoader__inner-wrapper">
			<div className="Spinner">
				<CircularProgress />
			</div>
		</div>
	</div>
);

export default PageLoader;
